module.exports = __webpack_public_path__ + "img/card_informe_eden_disciplina.4ac15008.svg";